import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BarChart = ({ TotalCount, summaryType, loading, startDate, endDate }) => {
  console.log(loading, 'loading');
  const currentYear = new Date().getFullYear();
  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  if (loading) {
    return <Skeleton height={200} />;
  }

  if (summaryType === 'lastyear') {
    const arrYearFirst = [];
    const previousYear = TotalCount?.previous?.data;
    Object.keys(previousYear).map((key) => {
      if (previousYear?.[key]) {
        arrYearFirst.push(previousYear?.[key]);
      }
    });

    //   previousYear?.forEach((el)=>{
    //     console.log(el)
    //     arrYearFirst.push(el);
    // })

    const arrYearSecond = [];
    const currentYearDate = TotalCount?.current?.data;
    Object.keys(currentYearDate).map((key) => {
      if (currentYearDate?.[key]) {
        arrYearSecond.push(currentYearDate?.[key]);
      }
    });

    //  currentYearDate?.forEach((em)=>{

    //   arrYearSecond.push(em);
    // })
    // const chartoptions={
    //     responsive: true,
    //     maintainAspectRatio : true
    // }

    const data = {
      labels: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],

      datasets: [
        {
          label: currentYear - 1,
          backgroundColor: '#a5cded',
          borderColor: '#80b5eb',
          borderWidth: 1,
          hoverBackgroundColor: '#80b5eb',
          hoverBorderColor: '#80b5eb',
          data: arrYearFirst, //TotalCount?.Year2021,
        },
        {
          label: currentYear,
          backgroundColor: '#556ee6',
          borderColor: '#556ee6',
          borderWidth: 1,
          hoverBackgroundColor: '#556ee6',
          hoverBorderColor: '#556ee6',
          data: arrYearSecond, //['2345698.49', '4112904.82', '4008363.28', '3582336.15', '2448549.78', '2725007.79', '3672460.04', '3750040.37', '5237634.12', '5618697.04', '4161897.97','0'] //TotalCount?.Year2022,
        },
      ],
    };

    if (windowSize.innerWidth <= 720) {
      return <Bar width={474} height={300} data={data} />;
    } else {
      return <Bar width={474} height={150} data={data} />;
    }
  } else if (summaryType === 'lastmonth' || summaryType === 'currentyearlastmonth') {
    // Always show all days, even if value is zero
    const previousMonth = Array.isArray(TotalCount?.previous?.data)
      ? TotalCount.previous.data
      : [];
    const currentMonthDate = Array.isArray(TotalCount?.current?.data)
      ? TotalCount.current.data
      : [];
    const maxDays = Math.max(previousMonth.length, currentMonthDate.length, 31);
    const labels = Array.from({ length: maxDays }, (_, i) => String(i + 1).padStart(2, '0'));
    const arrMonthFirst = Array.from({ length: maxDays }, (_, i) => previousMonth[i] ?? 0);
    const arrMonthSecond = Array.from({ length: maxDays }, (_, i) => currentMonthDate[i] ?? 0);

    let data;
    if (summaryType === 'currentyearlastmonth') {
      // Get last month and current month names
      const now = new Date();
      const currentMonthName = moment(now).format('MMMM');
      const lastMonthDate = moment(now).subtract(1, 'months');
      const lastMonthName = lastMonthDate.format('MMMM');
      data = {
        labels: labels,
        datasets: [
          {
            label: `${currentYear} ${lastMonthName}`,
            backgroundColor: '#a5cded',
            borderColor: '#80b5eb',
            borderWidth: 1,
            hoverBackgroundColor: '#80b5eb',
            hoverBorderColor: '#80b5eb',
            data: arrMonthFirst,
          },
          {
            label: `${currentYear} ${currentMonthName}`,
            backgroundColor: '#556ee6',
            borderColor: '#556ee6',
            borderWidth: 1,
            hoverBackgroundColor: '#556ee6',
            hoverBorderColor: '#556ee6',
            data: arrMonthSecond,
          },
        ],
      };
    } else {
      data = {
        labels: labels,
        datasets: [
          {
            label: currentYear - 1,
            backgroundColor: '#a5cded',
            borderColor: '#80b5eb',
            borderWidth: 1,
            hoverBackgroundColor: '#80b5eb',
            hoverBorderColor: '#80b5eb',
            data: arrMonthFirst,
          },
          {
            label: currentYear,
            backgroundColor: '#556ee6',
            borderColor: '#556ee6',
            borderWidth: 1,
            hoverBackgroundColor: '#556ee6',
            hoverBorderColor: '#556ee6',
            data: arrMonthSecond,
          },
        ],
      };
    }

    if (windowSize.innerWidth <= 720) {
      return <Bar width={474} height={300} data={data} />;
    } else {
      return <Bar width={474} height={150} data={data} />;
    }
  } else if (summaryType === 'custommonth') {
    let labels = [];
    if (startDate && endDate) {
      let start = moment(startDate, 'DD-MM-YYYY');
      let end = moment(endDate, 'DD-MM-YYYY');
      while (start.isSameOrBefore(end)) {
        labels.push(start.format('DD-MM-YYYY'));
        start.add(1, 'days');
      }
    } else {
      const daysInMonth = Array.isArray(TotalCount?.current?.data)
        ? TotalCount?.current?.data?.length
        : 31;
      // fallback: generate labels as '01-MM-YYYY', '02-MM-YYYY', ...
      const month = moment().format('MM-YYYY');
      labels = Array.from(
        { length: daysInMonth },
        (_, i) => String(i + 1).padStart(2, '0') + '-' + month
      );
    }

    // Ensure arrPrev and arrCurr match the labels length and are always arrays
    const prevData = TotalCount?.previous?.data || {};
    const currData = TotalCount?.current?.data || {};
    // If data is array, convert to object with full date string as key
    const prevObj = Array.isArray(prevData)
      ? Object.fromEntries(
        prevData.map((v, i) => {
          // Try to get the date string from labels if available
          const dateStr = labels[i];
          return [dateStr, v];
        })
      )
      : prevData;
    const currObj = Array.isArray(currData)
      ? Object.fromEntries(
        currData.map((v, i) => {
          const dateStr = labels[i];
          return [dateStr, v];
        })
      )
      : currData;
    const arrPrev = labels.map((date) => prevObj[date] ?? 0);
    const arrCurr = labels.map((date) => currObj[date] ?? 0);

    // For x-axis, show only the day part
    const labelDays = labels.map((date) => date.slice(0, 2));

    const data = {
      labels: labelDays,
      datasets: [
        {
          label: TotalCount?.previous?.year,
          backgroundColor: '#a5cded',
          borderColor: '#80b5eb',
          borderWidth: 1,
          hoverBackgroundColor: '#80b5eb',
          hoverBorderColor: '#80b5eb',
          data: arrPrev,
        },
        {
          label: TotalCount?.current?.year,
          backgroundColor: '#556ee6',
          borderColor: '#556ee6',
          borderWidth: 1,
          hoverBackgroundColor: '#556ee6',
          hoverBorderColor: '#556ee6',
          data: arrCurr,
        },
      ],
    };

    if (windowSize.innerWidth <= 720) {
      return <Bar width={474} height={300} data={data} />;
    } else {
      return <Bar width={474} height={150} data={data} />;
    }
  } else if (summaryType === 'lastweek') {
    let labels = [];
    const arrWeekFirst = [];
    const previousWeek = TotalCount?.previous?.data;

    Object.keys(previousWeek).forEach((key) => {
      if (previousWeek?.[key]) {
        arrWeekFirst.push(previousWeek?.[key]);
        labels.push(key);
      }
    });

    const arrWeekSecond = [];
    const currentweek = TotalCount?.current?.data;
    Object.keys(currentweek).forEach((key) => {
      if (currentweek?.[key]) {
        arrWeekSecond.push(currentweek?.[key]);
      }
    });

    const data = {
      labels: [
        'Monday',
        'Tuesday',
        'wednesday',
        'thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],

      datasets: [
        {
          label: currentYear - 1,
          backgroundColor: '#a5cded',
          borderColor: '#80b5eb',
          borderWidth: 1,
          hoverBackgroundColor: '#80b5eb',
          hoverBorderColor: '#80b5eb',
          data: arrWeekFirst, //TotalCount?.Year2021,
        },
        {
          label: currentYear,
          backgroundColor: '#556ee6',
          borderColor: '#556ee6',
          borderWidth: 1,
          hoverBackgroundColor: '#556ee6',
          hoverBorderColor: '#556ee6',
          data: arrWeekSecond, //['2345698.49', '4112904.82', '4008363.28', '3582336.15', '2448549.78', '2725007.79', '3672460.04', '3750040.37', '5237634.12', '5618697.04', '4161897.97','0'] //TotalCount?.Year2022,
        },
      ],
    };

    if (windowSize.innerWidth <= 720) {
      return <Bar width={474} height={300} data={data} />;
    } else {
      return <Bar width={474} height={150} data={data} />;
    }
  } else if (summaryType === 'currentyearlastweek') {
    let labels = [];
    const arrWeekFirst = [];
    const previousWeek = TotalCount?.previous?.data;

    Object.keys(previousWeek).forEach((key) => {
      if (previousWeek?.[key]) {
        arrWeekFirst.push(previousWeek?.[key]);
        labels.push(key);
      }
    });

    const arrWeekSecond = [];
    const currentweek = TotalCount?.current?.data;
    Object.keys(currentweek).forEach((key) => {
      if (currentweek?.[key]) {
        arrWeekSecond.push(currentweek?.[key]);
      }
    });

    const data = {
      labels: [
        'Monday',
        'Tuesday',
        'wednesday',
        'thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],

      datasets: [
        {
          label: currentYear,
          backgroundColor: '#a5cded',
          borderColor: '#80b5eb',
          borderWidth: 1,
          hoverBackgroundColor: '#80b5eb',
          hoverBorderColor: '#80b5eb',
          data: arrWeekFirst, //TotalCount?.Year2021,
        },
        {
          label: currentYear,
          backgroundColor: '#556ee6',
          borderColor: '#556ee6',
          borderWidth: 1,
          hoverBackgroundColor: '#556ee6',
          hoverBorderColor: '#556ee6',
          data: arrWeekSecond, //['2345698.49', '4112904.82', '4008363.28', '3582336.15', '2448549.78', '2725007.79', '3672460.04', '3750040.37', '5237634.12', '5618697.04', '4161897.97','0'] //TotalCount?.Year2022,
        },
      ],
    };

    if (windowSize.innerWidth <= 720) {
      return <Bar width={474} height={300} data={data} />;
    } else {
      return <Bar width={474} height={150} data={data} />;
    }
  } else if (summaryType === 'currentyearlastMonthlastweek') {
    let labels = [];
    const arrWeekFirst = [];
    const previousWeek = TotalCount?.previous?.data;

    Object.keys(previousWeek).forEach((key) => {
      if (previousWeek?.[key]) {
        arrWeekFirst.push(previousWeek?.[key]);
        labels.push(key);
      }
    });

    const arrWeekSecond = [];
    const currentweek = TotalCount?.current?.data;
    Object.keys(currentweek).forEach((key) => {
      if (currentweek?.[key]) {
        arrWeekSecond.push(currentweek?.[key]);
      }
    });

    const data = {
      labels: [
        'Monday',
        'Tuesday',
        'wednesday',
        'thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],

      datasets: [
        {
          label: currentYear,
          backgroundColor: '#a5cded',
          borderColor: '#80b5eb',
          borderWidth: 1,
          hoverBackgroundColor: '#80b5eb',
          hoverBorderColor: '#80b5eb',
          data: arrWeekFirst,
        },
        {
          label: currentYear,
          backgroundColor: '#556ee6',
          borderColor: '#556ee6',
          borderWidth: 1,
          hoverBackgroundColor: '#556ee6',
          hoverBorderColor: '#556ee6',
          data: arrWeekSecond,
        },
      ],
    };

    if (windowSize.innerWidth <= 720) {
      return <Bar width={474} height={300} data={data} />;
    } else {
      return <Bar width={474} height={150} data={data} />;
    }
  }
  //
};

export default BarChart;
